
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Les liens étroits avec l'Italie du Nord voisine, où la pandémie faisait rage, et le carnaval sont les causes les plus probables de ce triste bilan.  Plus de cent mille personnes avaient en effet célébré le carnaval de Rabadan à Bellinzone jusqu'au 24 février 2020. Puis le gouvernement tessinois a mis brusquement fin à l'événement. Un jour plus tard, la clinique Moncucco, à Lugano, signale le `}<a parentName="p" {...{
        "href": "https://www.24heures.ch/suisse/premier-cas-coronavirus-confirme-suisse/story/13533395"
      }}>{`premier patient testé positif au coronavirus`}</a>{` en Suisse.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;